<ul class='nav nav-pills mb-3 white-background' [class.underline]='!auth' [class.justify-content-center]='auth || modal'
    role='tablist'>
  <li *ngFor='let tab of tabs' class='nav-item' (click)='setSelected(tab)' [class.selected-tab]='selectedTab.id == tab.id'>
    <a class='nav-link tab button' [class.tab-auth]='auth' role='tab' aria-controls='pills-home'
       [class.active]='selectedTab.id == tab.id' [attr.aria-selected]="selectedTab.id == tab.id ? 'true' : 'false'">
      <img *ngIf='!modal && tab.image && tab.selectedImage' loading='lazy' [alt]='tab.name' class='tab-image'
           src='{{ selectedTab.id == tab.id ? tab.selectedImage : tab.image }}' width='24' height='24'>
      {{ tab.name }}
    </a>
  </li>
  <a *ngIf='viewAll' class='button view-all d-none d-pl-block' [langLink]="['royalty-free-music']">{{ 'actions.view-all' | lang }}</a>
</ul>

<div *ngIf='modal' class='or d-none d-t-block'>{{ 'common.or' | lang }}</div>
